import type {
  CardBodyProps,
  CardProps} from '@chakra-ui/react'
import {
  Card,
  CardBody,
  CardFooter,
  forwardRef,
} from '@chakra-ui/react'
import type { ReactNode } from 'react'

import type { FormSectionHeaderProps } from './FormSectionHeader'
import { FormSectionHeader } from './FormSectionHeader'

export interface FormSectionProps extends CardProps {
  number?: number | ReactNode
  sectionTitle?: string | ReactNode
  bodyProps?: CardBodyProps
  footer?: ReactNode
  wide?: boolean
  cardHeaderProps?: FormSectionHeaderProps
}

export const FormSection = forwardRef(
  (
    {
      children,
      number,
      sectionTitle,
      bodyProps,
      footer,
      wide = false,
      cardHeaderProps,
      ...rest
    }: FormSectionProps,
    ref,
  ) => {
    const { sx } = bodyProps || {}

    return (
      <Card ref={ref} {...rest}>
        <FormSectionHeader number={number} {...cardHeaderProps}>
          {sectionTitle}
        </FormSectionHeader>

        <CardBody
          sx={{
            px: { md: 8, lg: wide ? 8 : 24 },
            pb: { base: 8, md: wide ? 8 : 24 },
            '&:empty': {
              display: 'none',
            },
            ...sx,
          }}
        >
          {children}
        </CardBody>

        {footer && <CardFooter>{footer}</CardFooter>}
      </Card>
    )
  },
)
